import * as actionTypes from "../actionTypes";

export const saveWasteActivity = function (wasteActivity) {
  return { type: actionTypes.SAVE_WASTE_ACTIVITY, payload: wasteActivity };
};

export const resetWasteActivityStatus = function () {
  return { type: actionTypes.RESET_WASTE_ACTIVITY_STATUS };
};
